export enum FeatureFlags {
  PERF_STATS = 'enablePerfStats',
  DISABLE_REGISTRATION = 'disableRegistration',
  ENABLE_REGISTRATION_WITH_TOKEN = 'enableRegistrationWithToken',
  ENABLE_TASK_MESSAGES = 'enableTaskMessages',
}
